import React, { useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y } from "swiper";

import { parseTimeToSeconds } from "./videoEmbed";

import "swiper/css";
import "./videoModal.css";

const LandingVideoModal = ({
  isOpen,
  embed,
  playerRef,
  modalRef,
  videoTitle,
  chapters,
  onClose,
  onSeek,
}) => {
  const chapterList = useMemo(
    () =>
      (Array.isArray(chapters) ? chapters : [])
        .map((chapter) => ({
          label: chapter?.label || "",
          time: chapter?.time || "",
          seconds: parseTimeToSeconds(chapter?.time),
        }))
        .filter((chapter) => chapter.label || chapter.time),
    [chapters]
  );

  if (!isOpen || !embed) return null;

  return (
    <div
      className="landing_video_modal"
      role="dialog"
      aria-modal="true"
      aria-label={videoTitle || "Tutorial video"}
    >
      <button
        className="landing_video_modal__backdrop"
        type="button"
        aria-label="Close video"
        onClick={onClose}
      />

      <div className="landing_video_modal__content" ref={modalRef} tabIndex={-1}>
        <button
          className="landing_video_modal__close"
          type="button"
          aria-label="Close video"
          onClick={onClose}
        />

        <div className="landing_video_modal__player">
          {embed.type === "iframe" ? (
            <iframe
              ref={playerRef}
              src={embed.src}
              title={embed.title}
              referrerPolicy="strict-origin-when-cross-origin"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <video
              ref={playerRef}
              src={embed.src}
              controls
              autoPlay
              playsInline
            />
          )}
        </div>

        {chapterList.length > 0 && (
          <div className="landing_video_modal__chapters">
            <Swiper
              modules={[A11y]}
              slidesPerView="auto"
              spaceBetween={12}
              watchOverflow
            >
              {chapterList.map((chapter, index) => (
                <SwiperSlide
                  key={`${chapter.label}-${chapter.time}-${index}`}
                  className="landing_video_modal__chapter_slide"
                >
                  <button
                    className="landing_video_modal__chapter"
                    type="button"
                    onClick={() => onSeek(chapter.seconds)}
                    disabled={chapter.seconds == null}
                  >
                    {chapter.time && (
                      <span className="landing_video_modal__chapter_time">
                        {chapter.time}
                      </span>
                    )}
                    {chapter.label && (
                      <span className="landing_video_modal__chapter_label">
                        {chapter.label}
                      </span>
                    )}
                  </button>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>
    </div>
  );
};

export default LandingVideoModal;
